import styled from '@emotion/styled'

import { colors, spacing } from 'main/ui'

interface IProps {
  margin?: number
}

export default styled.div<IProps>`
  border-top: 1px solid ${colors.border.default};
  margin: ${props => (props.margin === undefined ? spacing.majorScale(4) : props.margin)}px 0;
  width: 100%;
`
